module.exports = __webpack_public_path__ + "static/camera10-9cbd4098fa0ef5337afee3bac1921f7d.jpg";